import React from 'react';

import { Tinode } from 'tinode-sdk';

import { sanitizeUrlForMime } from '../lib/utils.js';
import UserAvatarIcon from './user-avatar-icon.jsx';

export default class LetterTile extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      imageFailed: false,
    };

    this.handleImageError = this.handleImageError.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.avatar !== this.props.avatar) {
      this.setState({ imageFailed: false });
    }
  }

  handleImageError(e) {
    e.target.onerror = null;
    this.setState({ imageFailed: true });
  }

  renderDefaultAvatar(isGroup) {
    if (isGroup) {
      const className = 'default-avatar' + (this.props.deleted ? ' disabled' : '');
      const iconClassName = 'material-icons' + (this.props.deleted ? ' disabled' : '');
      return (
        <div className={className} aria-hidden="true">
          <i className={iconClassName}>group</i>
        </div>
      );
    }

    const className = 'default-avatar' + (this.props.deleted ? ' disabled' : '');
    return (
      <div className={className} aria-hidden="true">
        <UserAvatarIcon />
      </div>
    );
  }

  render() {
    const isGroup = Tinode.isGroupTopicName(this.props.topic);
    const hasImage = this.props.avatar && this.props.avatar !== true && !this.state.imageFailed;

    if (this.props.avatar === true || !hasImage) {
      return this.renderDefaultAvatar(isGroup);
    }

    const url = this.props.tinode.authorizeURL(sanitizeUrlForMime(this.props.avatar, 'image'));
    const className = 'avatar' + (this.props.deleted ? ' deleted' : '');
    return (
      <img
        className={className}
        alt="avatar"
        src={url}
        onError={this.handleImageError}
      />
    );
  }
}
